import * as React from "react";
import { If } from "../../../../core/components/If";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import {
    hideModal,
    showModal,
    showYesNoPrompt
} from "../../../../redux/reducers/ModalReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { DataSource } from "../../../../repertoire/types/DataSource";
import MultiStepForm, { Step } from "../../../components/multiStepForm/MultiStepForm";
import { sortColumn } from "../../../../redux/reducers/DataIngestionReducer";
import CueSheetsMaintenanceGeneralDataView from "../cueSheetsMaintenanceGeneralDataView/CueSheetsMaintenanceGeneralDataView";
import { IProductState } from "../../../../redux/types/IProductState";
import { ProductDetailsMapper } from "../../../../repertoire/services/ProductDetailsMapper";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { CURRENT_USER_NAME_KEY } from "../../../../redux/services/AccountSessionStorage";

export interface ICueSheetsMaintenancePageProps {
    cueSheetsMaintenanceGeneralDataView?: IMembersPortalComponentDataItem;
    cueSheetsMaintenanceGridsViewData?: IMembersPortalComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    activeTab: number;
    tabs: ITabReduxItem[];
    dataSource: DataSource;
    lookupValues?: ILookupDictionary;
    cueSheet: IProductState;
    hideModal: typeof hideModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    showModal: typeof showModal;
    clearModalSearchResults: () => void;
    incrementTempID?: () => void;
    sortColumn: typeof sortColumn;
    stepsCurrent?: number;
    stepsSetCurrent?: (current: number) => void;
    currentUser: string;
    currentUserNameNumber: string;
    portalType: string;
    updatedScroll?: number;
    getRegisteredWorkDetails?: (dataSource: string, registeredWorksID: number, lookupValues: ILookupDictionary, registeredWorkMaintenanceDataViewData: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    registeredWorksMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem;
}

interface ICueSheetsMaintenancePageState {
    toolbarWidth: number;
    isBulkCheckboxActive?: boolean;
}

export class CueSheetsMaintenancePage extends React.PureComponent<
    ICueSheetsMaintenancePageProps,
    ICueSheetsMaintenancePageState
> {
    constructor(props: ICueSheetsMaintenancePageProps) {
        super(props);
        this.state = {
            toolbarWidth: null,
            isBulkCheckboxActive: false
        };
    }

    render() {

        const {
            tabs,
            activeTab,
            cueSheetsMaintenanceGridsViewData,
            cueSheetsMaintenanceGeneralDataView,
            hideModal,
            dataGridTableData,
            showModal,
            clearModalSearchResults,
            incrementTempID,
            dataSource,
            stepsCurrent,
            stepsSetCurrent,
            currentUserNameNumber,
            getRegisteredWorkDetails,
            registeredWorksMaintenanceGeneralDataViewData
        } = this.props;

        let cueSheet = this.props.cueSheet;

        if (!cueSheet && currentUserNameNumber) {
            const userNameNumber = currentUserNameNumber;
            const userName = sessionStorage.getItem(CURRENT_USER_NAME_KEY);
            cueSheet = ProductDetailsMapper.createNewProductState(this.props.lookupValues, null, { ipiNameNumber: parseInt(userNameNumber), productSourceIPID: 0, fullName: userName });
        }

        const title = '';
        const changesMade = tabs[activeTab].changesMade || false;

        let steps: Step[] =
            [
                {
                    name: 'cueSheetListsDetails',
                    title: cueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'cueSheetListsDetails').data,
                    content: <CueSheetsMaintenanceGeneralDataView
                        cueSheetsMaintenanceGridsViewData={cueSheetsMaintenanceGridsViewData}
                        cueSheet={cueSheet}
                        isReadonly={true}
                        lookupValues={this.props.lookupValues}
                        showModal={showModal}
                        hideModal={hideModal}
                        activeTab={activeTab}
                        tabs={tabs}
                        incrementTempID={incrementTempID}
                        changesMade={changesMade}
                        activeHeaderSection={tabs[activeTab].activeHeaderSection}
                        dataGridTableData={dataGridTableData}
                        cueSheetsMaintenanceGeneralDataView={cueSheetsMaintenanceGeneralDataView}
                        clearModalSearchResults={clearModalSearchResults}
                        getRegisteredWorkDetails={getRegisteredWorkDetails}
                        registeredWorksMaintenanceGeneralDataViewData={registeredWorksMaintenanceGeneralDataViewData}
                    />
                }
            ];

        let zeroedStepsCurrent = stepsCurrent ?? 0;

        return (
            <div className="">
                <div><span className="title">{title}</span></div>                

                <button type="button" className="toolbar-toggle" data-toggle="collapse" data-target="#toolbarContainer">
                    <i className="icon ms-Icon ms-Icon--MoreVertical" aria-hidden="true"></i>
                </button>               

                <MultiStepForm
                    steps={steps}
                    readonly={false}
                    saveChanges={null}
                    confirmAndSubmit={null}
                    dataSource={dataSource}
                    current={zeroedStepsCurrent}
                    setCurrent={stepsSetCurrent}
                    multiStepFormViewData={cueSheetsMaintenanceGeneralDataView}
                />
            </div>
        );
    }
}
